module.exports = __webpack_public_path__ + "static/media/logo_login.4c4fc075.svg";